module.exports = __webpack_public_path__ + "map-image.f40ed5b1e791e9d2479b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/map-image.png
// module id = 173
// module chunks = 1